import { Link } from "gatsby"
import React from "react"
import BookAViewForm from "../forms/book-a-viewing-form"
import "./FixedButtons.scss"
import ModalTiny from "react-bootstrap/Modal"

const FixedButtons = props => {
  const { pageurl, property_title, property_img } = props;
  const [modalSendfrndformOpen, setSendfrndformOpen] = React.useState(false)
  const openSendfrndformModal = () => {
    setSendfrndformOpen(true)
  }
  const closeSendfrndformModal = () => {
    setSendfrndformOpen(false)
  }
  const hreftel = { href: "tel:+971043243137" }
  const hrefWp = { href: `https://wa.me/+971043243137` }
  return (
    <>
      <div className="fixed-buttons d-block d-xl-none">
        <div className="btns-fixed">
          <a
            href="javascript:void(0)"
            className="btn book-btn"
            onClick={openSendfrndformModal}
          >
            Book a Viewing
          </a>
          <Link {...hreftel} className="btn tel-btn">
            <i className="icon-telephone"></i>
            <span>+971 4 324 3137</span>
          </Link>
          <Link {...hrefWp} className="btn whatsapp-btn" target="_blank">
            <i className="icon-whatsapp"></i>
            <span>Click to WhatsApp</span>
          </Link>
        </div>
      </div>
      <ModalTiny
        show={modalSendfrndformOpen}
        onHide={closeSendfrndformModal}
        className="book-a-viewing-modal modal-main-form modal bg_white"
      >
        <i className="icon-close" onClick={() => closeSendfrndformModal()}></i>

        <ModalTiny.Body className="people-details-form-modal event-section">
          <h2>Book a Viewing</h2>
          <p>
            For more information, please leave a few details below and a member
            of our team will be in contact soon.
          </p>
          <BookAViewForm page_url={pageurl} property_title={property_title} property_img={property_img} />
        </ModalTiny.Body>
      </ModalTiny>
    </>
  )
}

export default FixedButtons
